import React, { useState } from "react";
import { Button, Group, Text } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import FiscalPeriodSelect from "./accounting/FiscalPeriodSelect";
import CommissionAnalysisView from "./accounting/CommissionAnalysisView";

const ReportCommissionAnalysis = () => {
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fiscalPeriodId, setFiscalPeriodId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const query = {};
      if (fiscalPeriodId) query.fiscalPeriodId = fiscalPeriodId;
      if (startDate) query.startDate = startDate.toISOString();
      if (endDate) query.endDate = endDate.toISOString();
      const data = await api.Accounting.getCommissionAnalysis(query);
      setReport(data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs" mb="xs">
        {t("Commission income vs expense analysis.")}
      </Text>
      <Group align="flex-end">
        <FiscalPeriodSelect
          value={fiscalPeriodId}
          onChange={setFiscalPeriodId}
          style={{ minWidth: 220 }}
        />
        <DatePicker
          size="xs"
          label={t("From")}
          placeholder="From"
          value={startDate}
          onChange={setStartDate}
          allowFreeInput
          clearable
        />
        <DatePicker
          size="xs"
          label={t("To")}
          placeholder="To"
          value={endDate}
          onChange={setEndDate}
          allowFreeInput
          clearable
        />
        <Button size="xs" onClick={load} loading={loading}>
          {t("Run Report")}
        </Button>
      </Group>
      <div style={{ marginTop: 16 }}>
        {report && <CommissionAnalysisView report={report} />}
      </div>
    </div>
  );
};

export default ReportCommissionAnalysis;
